export const sections = [
  {
    slug: 'entertainment',
    name: '娱乐区',
    shortName: '娱乐',
    tagline: '综艺、剧集与舞台话题',
    description:
      '聚焦近期综艺赛制、剧集口碑和舞台表现，整理值得一看的看点与幕后讨论，更新节奏快，适合下饭时快速浏览。',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'society',
    name: '社会区',
    shortName: '社会',
    tagline: '城市生活与公共话题',
    description:
      '记录城市里正在发生的生活方式变化，从社区食堂到夜校、公园野餐，用轻松的角度看身边的热点。',
    icon: 'ri-building-2-line',
  },
  {
    slug: 'tech',
    name: '科技圈',
    shortName: '科技',
    tagline: '新品、AI 与数码风向',
    description:
      '追踪数码新品与人工智能话题，把发布会上的参数翻译成日常能用到的东西，帮你看清这一轮风向。',
    icon: 'ri-cpu-line',
  },
  {
    slug: 'sports',
    name: '体育圈',
    shortName: '体育',
    tagline: '赛事、球队与赛场花絮',
    description:
      '联赛、马拉松和城市运动的现场观察，既有比分和阵容，也有赛场外那些容易被忽略的有趣片段。',
    icon: 'ri-basketball-line',
  },
  {
    slug: 'influencer',
    name: '网红圈',
    shortName: '网红圈',
    tagline: '主播、博主与内容生态',
    description:
      '关注直播与短视频创作者的生态变化，从慢直播到知识博主，看内容行业正在往哪个方向走。',
    icon: 'ri-live-line',
  },
];